import {darken, lighten, transparentize} from 'polished';

const colors = {
  purpSoft: '#4B2AAD',
  purpBright: '#9484C6',
  dark: '#1A1715',
  soft: '#5C5856',
  bright: '#9C8881',
  light: '#DFD8D3',
  pale: '#F5EFEB',
  white: '#fdfbf9',
  pureWhite: '#fff',
  red: '#F03A47',
};

const theme = {
  body: {
    bg: colors.pale,
  },
  link: {
    default: colors.purpSoft,
    hover: darken(0.1, colors.purpSoft),
    active: darken(0.2, colors.purpSoft),
  },
  button: {
    primary: {
      default: {
        bg: colors.purpSoft,
        shadow: '0px 2px 4px rgba(0, 0, 0, 0.15)',
        text: colors.pureWhite,
      },
      hover: {
        bg: darken(0.1, colors.purpSoft),
        shadow: '0px 2px 4px rgba(0, 0, 0, 0.15)',
        text: colors.pureWhite,
      },
      active: {
        bg: darken(0.2, colors.purpSoft),
        text: colors.pureWhite,
      },
      disabled: {
        bg: transparentize(0.6, colors.purpSoft),
        text: colors.pureWhite,
      },
    },
    secondary: {
      default: {
        bg: colors.light,
        text: colors.dark,
      },
      hover: {
        bg: darken(0.1, colors.light),
        text: colors.dark,
      },
      active: {
        bg: darken(0.2, colors.light),
        text: colors.dark,
      },
      disabled: {
        bg: colors.light,
        text: lighten(0.1, colors.light),
      },
    },
  },
  input: {
    default: {
      bg: colors.pureWhite,
      border: `1px solid ${colors.light}`,
      text: colors.dark,
    },
    focus: {
      bg: colors.pureWhite,
      border: `1px solid ${colors.bright}`,
      text: colors.dark,
    },
    invalid: {
      bg: colors.pureWhite,
      border: `1px solid ${colors.red}`,
      text: colors.dark,
    },
  },
  radio: {
    default: {
      bg: colors.pureWhite,
      border: `1px solid ${colors.light}`,
    },
    checked: {
      bg: colors.dark,
      innerBg: colors.pureWhite,
      border: `1px solid ${colors.dark}`,
    },
  },
  richTextarea: {
    bg: colors.pureWhite,
    border: colors.light,
    toolbar: {
      border: colors.light,
    },
    button: {
      default: {
        bg: 'transparent',
      },
      hover: {
        bg: colors.pale,
      },
      active: {
        bg: colors.light,
      },
    },
  },
  select: {
    default: {
      bg: colors.pureWhite,
      border: colors.light,
      text: colors.dark,
    },
    focus: {
      bg: colors.pale,
      border: colors.bright,
      text: colors.dark,
    },
  },
  fieldset: {
    title: colors.dark,
    subtitle: colors.bright,
    description: colors.soft,
  },
  group: {
    bg: colors.white,
    border: `1px solid ${colors.light}`,
  },
  label: {
    title: colors.dark,
    description: colors.soft,
    optionalDot: colors.light,
  },
  tooltip: {
    bg: colors.dark,
    text: colors.pureWhite,
  },
};

export default theme;
